import { useParams } from "react-router-dom";
import PillowView from "./gallery/PillowView";
import OrnamentView from "./gallery/OrnamentView";
import JobView from "./gallery/JobView";

function useDetailId(): string {
  const { id } = useParams<{ id: string }>();
  if (id === undefined) throw new Error("Gallery detail route has no :id parameter");
  return id;
}

/** `/gallery/pillows/:id` — the item kind lives in the URL, so direct links and reloads resolve it. */
export function PillowDetailPage() {
  return <PillowView id={useDetailId()} />;
}

/** `/gallery/ornaments/:id`. */
export function OrnamentDetailPage() {
  return <OrnamentView id={useDetailId()} />;
}

/** `/gallery/serverless/:id`. */
export function JobDetailPage() {
  return <JobView jobId={useDetailId()} />;
}
